import React, { useEffect, useState } from "react";
import { Card, Spin, Tag, Button, message } from "antd";
import { useParams, useNavigate } from "react-router-dom";
import { getJobsApi } from "../../../apiservice/ats";

const JobView = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [job, setJob] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const loadJob = async () => {
            try {
                setLoading(true);
                const res = await getJobsApi({ id });
                setJob(Array.isArray(res.data) ? res.data[0] : res.data);
                setLoading(false);
            } catch (err) {
                console.error(err);
                message.error("Failed to load job");
                setLoading(false);
            }
        };
        loadJob();
    }, [id]);

    if (loading) return <Spin size="large" style={{ display: "block", margin: 40 }} />;
    if (!job) return <div>Job not found</div>;

    return (
        <Card
            title={job.title}
            extra={<Button onClick={() => navigate(`/ats/jobs/${id}/edit`)}>Edit</Button>}
            style={{ maxWidth: 600, margin: "40px auto" }}
        >
            <p><strong>Client:</strong> {job.client}</p>
            <p><strong>Location:</strong> {job.location}</p>
            <p><strong>Type:</strong> {job.job_type}</p>
            <p>
                <strong>Status:</strong>{" "}
                {job.status === "active" ? <Tag color="green">Open</Tag> : <Tag color="red">Closed</Tag>}
            </p>
            <p><strong>Description:</strong> {job.description || "-"}</p>
            <p>
                <strong>Shareable Link:</strong>{" "}
                <a href={`${window.location.origin}/jobs/${job.id}`} target="_blank" rel="noopener noreferrer">
                    {window.location.origin}/jobs/{job.id}
                </a>
            </p>
        </Card>
    );
};

export default JobView;
